import React, { useState, useEffect, forwardRef } from 'react';

//komponen
import { withStyles } from '@mui/styles';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import Grid from '@mui/material/Grid';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import Fab from '@mui/material/Fab';
import ButtonGroup from '@mui/material/ButtonGroup';
import LoadingButton from '@mui/lab/LoadingButton';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Divider from '@mui/material/Divider';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Paper from '@mui/material/Paper';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import InputAdornment from '@mui/material/InputAdornment';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import Link from '@mui/material/Link';
import Switch from '@mui/material/Switch';

//gambar
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import PrintIcon from '@mui/icons-material/Print';
import SearchOutlined from '@mui/icons-material/SearchOutlined';

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "rgba(108,122,224,255)",
        borderColor: "rgba(108,122,224,255)",
        color: "white"
    }
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: "rgba(248,246,255,255)",
            borderColor: "rgba(248,246,255,255)"
        },
    },
}))(TableRow);

function Pembayaran(props, ref) {
    //state
    const [proses, setProses] = useState(false);
    const [tampil_notif, setTampilNotif] = useState(false);
    const [jenis_notif, setJenisNotif] = useState("success");
    const [isi_notif, setIsiNotif] = useState("");
    const [data_pesanan, setDataPesanan] = useState([]);
    const [data_metode_bayar, setDataMetodeBayar] = useState([]);
    const [id_pesanan, setIdPesanan] = useState("");
    const [ppn, setPpn] = useState(0);
    const [ppn_dine_in, setPpnDineIn] = useState(false);
    const [ppn_take_away, setPpnTakeAway] = useState(false);
    const [tampung_biaya_lainnya, setTampungBiayaLainnya] = useState(0);
    const [biaya_lainnya, setBiayaLainnya] = useState(0);
    const [nama, setNama] = useState("");
    const [metode, setMetode] = useState("D");
    const [no_meja, setNoMeja] = useState("");
    const [pelayan, setPelayan] = useState("");
    const [waktu_pesan, setWaktuPesan] = useState("");
    const [data_input_pesanan, setDataInputPesanan] = useState([]);
    const [data_jenis, setDataJenis] = useState([]);
    const [jenis, setJenis] = useState("");
    const [data_produk, setDataProduk] = useState([]);
    const [jumlah_metode_bayar, setJumlahMetodeBayar] = useState("M1");
    const [metode_bayar, setMetodeBayar] = useState("M1");
    const [metode_bayar2, setMetodeBayar2] = useState("");
    const [tambah_jual, setTambahJual] = useState(0);
    const [no_telpon, setNoTelpon] = useState("");
    const [dp, setDp] = useState(0);
    const [jumlah_bayar, setJumlahBayar] = useState(0);
    const [jumlah_bayar2, setJumlahBayar2] = useState(0);
    const [metode_diskon, setMetodeDiskon] = useState("nominal");
    const [diskon_persen, setDiskonPersen] = useState(0);
    const [diskon, setDiskon] = useState(0);
    // const [kembalian, setKembalian] = useState(0);
    const [status_biaya_lainnya, setstatus_biaya_lainnyaBiayaLainnya] = useState(false);
    const [id_bayar, setIdBayar] = useState("");
    const [tampil_dialog, setTampilDialog] = useState(false);
    const [tampil_dialog_produk, setTampilDialogProduk] = useState(false);
    const [tampil_dialog_bayar, setTampilDialogBayar] = useState(false);

    const [pencarian, setPencarian] = useState("");
    const [jumlah_baris] = useState(20);
    const [jumlah_halaman, setJumlahHalaman] = useState(0);
    const [halaman, setHalaman] = useState(1);

    //fungsi
    useEffect(() => {
        fetch(props.aplikasi + '/kasir/tampil_pesanan.php',
            {
                method: 'GET',
                headers:
                {
                    "Content-type": "application/json; charset=UTF-8"
                }
            })
            .then(response => response.json())
            .then(data => {
                if (data.kode === 1) {
                    setDataPesanan(data.data);
                }
                else {
                    setDataPesanan([]);
                }
            })
            .catch(error => {
                setDataPesanan([]);
            }
            );

        fetch(props.aplikasi + '/metode_bayar/tampil_metode_bayar.php',
            {
                method: 'POST',
                body: JSON.stringify
                    ({
                        status: "ada"
                    }),
                headers:
                {
                    "Content-type": "application/json; charset=UTF-8"
                }
            })
            .then(response => response.json())
            .then(data => {
                if (data.kode === 1) {
                    setDataMetodeBayar(data.data);
                }
                else {
                    setDataMetodeBayar([]);
                }
            })
            .catch(error => {
                setDataMetodeBayar([]);
            }
            );

        setInterval(() => {
            fetch(props.aplikasi + '/kasir/tampil_pesanan.php',
                {
                    method: 'GET',
                    headers:
                    {
                        "Content-type": "application/json; charset=UTF-8"
                    }
                })
                .then(response => response.json())
                .then(data => {
                    if (data.kode === 1) {
                        setDataPesanan(data.data);
                    }
                    else {
                        setDataPesanan([]);
                    }
                })
                .catch(error => {
                    setDataPesanan([]);
                }
                );
        }, 10000)

    }, [props.aplikasi]);

    const format_rupiah = (angka) => {
        return (
            angka
                .toFixed(2)
                .replace(".", ",")
                .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
        )
    }

    const tutup_notif = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }

        setTampilNotif(false);
    };

    const tampil_pesanan = () => {
        setProses(true);
        fetch(props.aplikasi + '/kasir/tampil_pesanan.php',
            {
                method: 'GET',
                headers:
                {
                    "Content-type": "application/json; charset=UTF-8"
                }
            })
            .then(response => response.json())
            .then(data => {
                if (data.kode === 1) {
                    setDataPesanan(data.data);
                    setProses(false);
                }
                else {
                    setDataPesanan([]);
                    setProses(false);
                }
            })
            .catch(error => {
                setDataPesanan([]);
                setProses(false);
            }
            );
    }

    const tampil_pesanan_detail = (id_pesanan) => {
        setProses(true);
        fetch(props.aplikasi + '/kasir/tampil_pesanan_detail.php',
            {
                method: 'POST',
                body: JSON.stringify
                    ({
                        id_pesanan: id_pesanan
                    }),
                headers:
                {
                    "Content-type": "application/json; charset=UTF-8"
                }
            })
            .then(response => response.json())
            .then(data => {
                if (data.kode === 1) {
                    setDataInputPesanan(data.data);

                    // var tampung = data.data;
                    // var tampung_total = 0;
                    // var awal = 1;
                    // var akhir = tampung.length;
                    // while (awal <= akhir) {
                    //     tampung_total = tampung_total + parseFloat(tampung[awal - 1]["subtotal"]);
                    //     // tampung_total = tampung_total + parseFloat(tampung[awal - 1]["jumlah"]) * (parseFloat(tampung[awal - 1]["harga"]- tampung[awal - 1]["diskon_nominal"]));
                    //     awal++;
                    // }

                    // setTotal(tampung_total);
                    setTampilDialog(true);
                    setProses(false);
                }
                else {
                    setDataInputPesanan([]);
                    // setTotal(0);
                    setProses(false);
                }
            })
            .catch(error => {
                setDataInputPesanan([]);
                // setTotal(0);
                setProses(false);
            }
            );
    }

    const ubah_no_telpon = (event) => {
        const re = /^[0-9\b]+$/;
        if (re.test(event.target.value) === false && event.target.value !== "") {
            return;
        }

        setNoTelpon(event.target.value);
    }

    const switch_metode = (param) => {
        switch (param) {
            case "D":
                return "Dine-In";
            case "T":
                return "Take Away";
            default:
                break;
        }
    }

    const switch_warna_metode = (param) => {
        switch (param) {
            case "D":
                return "#e3855f";
            case "T":
                return "#de88e0";
            default:
                break;
        }
    }

    const tampil_jenis = () => {
        return new Promise((resolve) => {
            fetch(props.aplikasi + '/jenis_produk/tampil_jenis_produk.php',
                {
                    method: 'POST',
                    body: JSON.stringify
                        ({
                            status_biaya_lainnya: "1"
                        }),
                    headers:
                    {
                        "Content-type": "application/json; charset=UTF-8"
                    }
                })
                .then(response => response.json())
                .then(data => {
                    if (data.kode === 1) {
                        resolve(data.data);
                    }
                    else {
                        resolve([]);
                    }
                })
                .catch(error => {
                    resolve([]);
                }
                );
        });
    }

    // const tampil_produk = (id_jenis) => {
    //     return new Promise((resolve) => {
    //         fetch(props.aplikasi + '/produk/tampil_produk.php',
    //             {
    //                 method: 'POST',
    //                 body: JSON.stringify
    //                     ({
    //                         status_biaya_lainnya: "1"
    //                     }),
    //                 headers:
    //                 {
    //                     "Content-type": "application/json; charset=UTF-8"
    //                 }
    //             })
    //             .then(response => response.json())
    //             .then(data => {
    //                 if (data.kode === 1) {
    //                     if (id_jenis !== "" && id_jenis !== null) {
    //                         var awal = 1;
    //                         var akhir = data.data.length;

    //                         var tampung = [];
    //                         while (awal <= akhir) {
    //                             if (data.data[awal - 1]["id_jenis"] === id_jenis) {
    //                                 tampung.push(data.data[awal - 1]);
    //                             }
    //                             awal++;
    //                         }

    //                         resolve(tampung);
    //                         return;
    //                     }
    //                     resolve(data.data);
    //                 }
    //                 else {
    //                     resolve([]);
    //                 }
    //             })
    //             .catch(error => {
    //                 resolve([]);
    //             }
    //             );
    //     });
    // }

    const tampil_produk = (id_jenis, halaman_baru) => {
        return new Promise((resolve) => {
            fetch(props.aplikasi + '/produk/tampil_produk_limit.php',
                {
                    method: 'POST',
                    body: JSON.stringify
                        ({
                            status_biaya_lainnya: "1",
                            jenis: id_jenis,
                            cari: pencarian,
                            jumlah_baris: jumlah_baris,
                            halaman: halaman_baru
                        }),
                    headers:
                    {
                        "Content-type": "application/json; charset=UTF-8"
                    }
                })
                .then(response => response.json())
                .then(data => {
                    if (data.kode === 1) {
                        if (id_jenis !== "" && id_jenis !== null) {
                            setJumlahHalaman(Math.ceil(data.jumlah_data / jumlah_baris));
                            resolve(data.data);
                            return;
                        }
                        resolve(data.data);
                    }
                    else {
                        resolve([]);
                    }
                })
                .catch(error => {
                    resolve([]);
                }
                );
        });
    }

    // const cari = (event) => {
    //     var cari = (event.target.value).toLowerCase();
    //     var awal = 1;
    //     var akhir = sumber_produk.length;

    //     var posisi = 0;
    //     var tampung = [];
    //     while (awal <= akhir) {
    //         var hasil = ((sumber_produk[awal - 1]["nama"]).toLowerCase()).indexOf(cari);
    //         if (hasil === -1) {
    //             hasil = ((sumber_produk[awal - 1]["nama"]).toLowerCase()).indexOf(cari);
    //         }

    //         if (hasil !== -1) {
    //             tampung[posisi] = sumber_produk[awal - 1];
    //             posisi++;
    //         }
    //         awal++;
    //     }

    //     setDataProduk(tampung);
    // }

    const cari = async () => {
        setProses(true);
        setHalaman(1);
        const proses_produk = await tampil_produk(jenis, 1);
        setDataProduk(proses_produk);
        setProses(false);
    }

    const pindah_halaman = async (halaman_baru) => {
        setProses(true);
        setHalaman(halaman_baru);
        const proses_produk = await tampil_produk(jenis, halaman_baru);
        setDataProduk(proses_produk);
        setProses(false);
    }

    const ubah_jenis_produk = async (id_jenis) => {
        setProses(true);
        setJenis(id_jenis);
        setHalaman(1);
        const proses_produk = await tampil_produk(id_jenis, 1);
        setDataProduk(proses_produk);
        setProses(false);
    }

    // const tambah_pesanan = (id_produk, no_tambahan) => {
    //     var tampung = data_input_pesanan;
    //     var awal = 1;
    //     var akhir = tampung.length;
    //     while (awal <= akhir) {
    //         if (tampung[awal - 1]["id_produk"] === id_produk && tampung[awal - 1]["no_tambahan"] === no_tambahan) {
    //             tampung[awal - 1]["jumlah"] = parseInt(tampung[awal - 1]["jumlah"]) + 1;
    //             // tampung[awal - 1]["subtotal"] = parseInt(tampung[awal - 1]["jumlah"]) * parseInt(tampung[awal - 1]["harga"]);
    //             tampung[awal - 1]["subtotal"] = parseFloat(tampung[awal - 1]["jumlah"]) * (parseFloat(tampung[awal - 1]["harga"] - tampung[awal - 1]["diskon_nominal"]));
    //             tampung[awal - 1]["subtotal2"] = format_rupiah(tampung[awal - 1]["subtotal"]);
    //             break;
    //         }
    //         awal++;
    //     }

    //     var tampung_total = 0;
    //     awal = 1;
    //     akhir = tampung.length;
    //     while (awal <= akhir) {
    //         tampung_total = tampung_total + parseFloat(tampung[awal - 1]["subtotal"]);
    //         awal++;
    //     }

    //     setDataInputPesanan(tampung);
    //     setTotal(tampung_total);
    // }

    // const kurang_pesanan = (id_produk, jumlah_minimal, no_tambahan) => {
    //     var tampung = data_input_pesanan;
    //     var awal = 1;
    //     var akhir = tampung.length;
    //     while (awal <= akhir) {
    //         if (tampung[awal - 1]["id_produk"] === id_produk && tampung[awal - 1]["no_tambahan"] === no_tambahan) {
    //             if (parseInt(tampung[awal - 1]["jumlah"]) - 1 < 1) {
    //                 return;
    //             }

    //             if (parseInt(tampung[awal - 1]["jumlah"]) - 1 < parseInt(jumlah_minimal)) {
    //                 return;
    //             }
    //             tampung[awal - 1]["jumlah"] = parseInt(tampung[awal - 1]["jumlah"]) - 1;
    //             // tampung[awal - 1]["subtotal"] = parseInt(tampung[awal - 1]["jumlah"]) * parseInt(tampung[awal - 1]["harga"]);
    //             tampung[awal - 1]["subtotal"] = parseFloat(tampung[awal - 1]["jumlah"]) * (parseFloat(tampung[awal - 1]["harga"] - tampung[awal - 1]["diskon_nominal"]));
    //             tampung[awal - 1]["subtotal2"] = format_rupiah(parseInt(tampung[awal - 1]["subtotal"]));
    //             break;
    //         }
    //         awal++;
    //     }

    //     var tampung_total = 0;
    //     awal = 1;
    //     akhir = tampung.length;
    //     while (awal <= akhir) {
    //         tampung_total = tampung_total + parseFloat(tampung[awal - 1]["subtotal"]);
    //         awal++;
    //     }

    //     setDataInputPesanan(tampung);
    //     setTotal(tampung_total);
    // }

    // const ubah_jumlah_pesanan = (event, id_produk, no_tambahan) => {
    //     const re = /^[0-9\b]+$/;
    //     if (re.test(event.target.value) === false && event.target.value !== "") {
    //         return;
    //     }

    //     var tampung = data_input_pesanan;
    //     var awal = 1;
    //     var akhir = tampung.length;
    //     while (awal <= akhir) {
    //         if (tampung[awal - 1]["id_produk"] === id_produk && tampung[awal - 1]["no_tambahan"] === no_tambahan) {
    //             tampung[awal - 1]["jumlah"] = event.target.value;
    //             // tampung[awal - 1]["subtotal"] = parseInt(tampung[awal - 1]["jumlah"]) * parseInt(tampung[awal - 1]["harga"]);
    //             tampung[awal - 1]["subtotal"] = parseFloat(tampung[awal - 1]["jumlah"]) * (parseFloat(tampung[awal - 1]["harga"] - tampung[awal - 1]["diskon_nominal"]));
    //             tampung[awal - 1]["subtotal2"] = format_rupiah(tampung[awal - 1]["subtotal"]);
    //             break;
    //         }
    //         awal++;
    //     }

    //     var tampung_total = 0;
    //     awal = 1;
    //     akhir = tampung.length;
    //     while (awal <= akhir) {
    //         tampung_total = tampung_total + parseFloat(tampung[awal - 1]["subtotal"]);
    //         awal++;
    //     }

    //     setDataInputPesanan(tampung);
    //     setTotal(tampung_total);
    // }

    // const perbaiki_pesanan = (event, id_produk, jumlah_minimal, no_tambahan) => {
    //     var tampung = data_input_pesanan;
    //     var awal = 1;
    //     var akhir = tampung.length;
    //     while (awal <= akhir) {
    //         if (tampung[awal - 1]["id_produk"] === id_produk && tampung[awal - 1]["no_tambahan"] === no_tambahan) {
    //             if (parseFloat(event.target.value) > 0) {
    //                 if (parseInt(event.target.value) < parseInt(jumlah_minimal)) {
    //                     tampung[awal - 1]["jumlah"] = jumlah_minimal;
    //                 }
    //                 else {
    //                     tampung[awal - 1]["jumlah"] = event.target.value;
    //                 }
    //             }
    //             else {
    //                 tampung[awal - 1]["jumlah"] = jumlah_minimal;
    //             }
    //             // tampung[awal - 1]["subtotal"] = tampung[awal - 1]["jumlah"] * tampung[awal - 1]["harga"];
    //             tampung[awal - 1]["subtotal"] = parseFloat(tampung[awal - 1]["jumlah"]) * (parseFloat(tampung[awal - 1]["harga"] - tampung[awal - 1]["diskon_nominal"]));
    //             tampung[awal - 1]["subtotal2"] = format_rupiah(tampung[awal - 1]["subtotal"]);
    //             break;
    //         }
    //         awal++;
    //     }

    //     var tampung_total = 0;
    //     awal = 1;
    //     akhir = tampung.length;
    //     while (awal <= akhir) {
    //         tampung_total = tampung_total + parseFloat(tampung[awal - 1]["subtotal"]);
    //         awal++;
    //     }

    //     setDataInputPesanan(tampung);
    //     setTotal(tampung_total);
    // }

    // const hapus_pesanan = (id_produk) => {
    //     var tampung = data_input_pesanan;
    //     var awal = 1;
    //     var akhir = tampung.length;
    //     while (awal <= akhir) {
    //         if (tampung[awal - 1]["id_produk"] === id_produk) {
    //             delete tampung[awal - 1];
    //             break;
    //         }
    //         awal++;
    //     }

    //     tampung = tampung.filter(function (element) {
    //         return element !== undefined;
    //     });

    //     var tampung_total = 0;
    //     awal = 1;
    //     akhir = tampung.length;
    //     while (awal <= akhir) {
    //         tampung[awal - 1]["no"] = awal;
    //         tampung_total = tampung_total + parseFloat(tampung[awal - 1]["subtotal"]);
    //         awal++;
    //     }

    //     setDataInputPesanan(tampung);
    //     setTotal(tampung_total);
    // }

    const tambah_pesanan = (index) => {
        let tampung = [...data_input_pesanan];
        tampung[index]["jumlah"] = parseInt(tampung[index]["jumlah"]) + 1;
        setDataInputPesanan(tampung);
    }

    const kurang_pesanan = (index) => {
        let tampung = [...data_input_pesanan];
        if (parseInt(tampung[index]["jumlah"]) - 1 < 1) {
            return;
        }
        tampung[index]["jumlah"] = parseInt(tampung[index]["jumlah"]) - 1;
        setDataInputPesanan(tampung);
    }

    const ubah_jumlah_pesanan = (event, index) => {
        const re = /^[0-9\b]+$/;
        if (re.test(event.target.value) === false && event.target.value !== "") {
            return;
        }

        var tampung = [...data_input_pesanan];
        tampung[index]["jumlah"] = event.target.value;
        setDataInputPesanan(tampung);
    }

    const perbaiki_pesanan = (event, index) => {
        var tampung = [...data_input_pesanan];
        if (parseFloat(event.target.value) > 0) {
            tampung[index]["jumlah"] = event.target.value;
        }
        else {
            tampung[index]["jumlah"] = 1;
        }
        setDataInputPesanan(tampung);
    }

    const ubah_catatan = (event, index) => {
        var tampung = [...data_input_pesanan];
        tampung[index]["catatan"] = event.target.value;
        setDataInputPesanan(tampung);
    }

    const hapus_pesanan = (index) => {
        var tampung = [...data_input_pesanan];
        delete tampung[index];

        tampung = tampung.filter(function (element) {
            return element !== undefined;
        });

        setDataInputPesanan(tampung);
    }

    const hitung_total = () => {
        let total = 0;
        let tampung = [...data_input_pesanan];
        let awal = 1;
        let akhir = [...data_input_pesanan].length;

        while (awal <= akhir) {
            total = total + (tampung[awal - 1].jumlah * (tampung[awal - 1].harga - tampung[awal - 1].diskon_nominal));
            awal++;
        }

        total = total + (total * tambah_jual / 100);

        return total;
    }

    const hitung_ppn = () => {
        let pajak = 0;
        if (metode === "D" && ppn_dine_in === true) {
            pajak = (ppn / 100) * (parseFloat(hitung_total()) - parseFloat(diskon));
        }
        else if (metode === "T" && ppn_take_away === true) {
            pajak = (ppn / 100) * (parseFloat(hitung_total()) - parseFloat(diskon));
        }

        return pajak;
    }

    const hitung_biaya_lainnya = () => {
        let biaya = (biaya_lainnya / 100) * (parseFloat(hitung_total()) - parseFloat(diskon));

        return biaya;
    }

    const hitung_pembulatan = () => {
        let grand_total = parseFloat(hitung_total()) - parseFloat(diskon) + hitung_ppn() + hitung_biaya_lainnya();
        let pembulatan = Math.round(grand_total / 100) * 100 - grand_total;
        return pembulatan;
    }

    const hitung_kembalian = () => {
        let kembalian = parseFloat(jumlah_bayar) + parseFloat(jumlah_bayar2) - hitung_total() + parseFloat(diskon) - hitung_ppn() - hitung_biaya_lainnya() - hitung_pembulatan();
        return kembalian;
    }

    const ubah_jumlah_bayar = (event) => {
        const re = /^[0-9\b]+$/;
        if (re.test(event.target.value) === false && event.target.value !== "") {
            return;
        }
        setJumlahBayar(event.target.value);
        // setKembalian(parseInt(event.target.value) + parseInt(jumlah_bayar2) + parseInt(diskon) + parseInt(dp) - parseInt(total));
    }

    const perbaiki_jumlah_bayar = (event) => {
        if (parseFloat(event.target.value) > 0) {
            setJumlahBayar(event.target.value);
            // setKembalian(parseInt(event.target.value) + parseInt(jumlah_bayar2) + parseInt(diskon) + parseInt(dp) - parseInt(total));
        }
        else {
            setJumlahBayar(0);
            // setKembalian(parseInt(0) + parseInt(jumlah_bayar2) + parseInt(diskon) + parseInt(dp) - parseInt(total));
        }
    }

    const ubah_jumlah_bayar2 = (event) => {
        const re = /^[0-9\b]+$/;
        if (re.test(event.target.value) === false && event.target.value !== "") {
            return;
        }
        setJumlahBayar2(event.target.value);
        // setKembalian(parseInt(jumlah_bayar) + parseInt(event.target.value) + parseInt(diskon) + parseInt(dp) - parseInt(total));
    }

    const perbaiki_jumlah_bayar2 = (event) => {
        if (parseFloat(event.target.value) > 0) {
            setJumlahBayar2(event.target.value);
            // setKembalian(parseInt(jumlah_bayar) + parseInt(event.target.value) + parseInt(diskon) + parseInt(dp) - parseInt(total));
        }
        else {
            setJumlahBayar2(0);
            // setKembalian(parseInt(jumlah_bayar) + parseInt(0) + parseInt(diskon) + parseInt(dp) - parseInt(total));
        }
    }

    const ubah_diskon = (event) => {
        const re = /^[0-9\b]+$/;
        if (re.test(event.target.value) === false && event.target.value !== "") {
            return;
        }
        setDiskon(event.target.value);
        // setKembalian(parseInt(jumlah_bayar) + parseInt(jumlah_bayar2) + parseInt(event.target.value) + parseInt(dp) - parseInt(total));
    }

    const perbaiki_diskon = (event) => {
        if (parseFloat(event.target.value) > 0) {
            setDiskon(event.target.value);
            // setKembalian(parseInt(jumlah_bayar) + parseInt(jumlah_bayar2) + parseInt(event.target.value) + parseInt(dp) - parseInt(total));
        }
        else {
            setDiskon(0);
            // setKembalian(parseInt(jumlah_bayar) + parseInt(jumlah_bayar2) + parseInt(0) + parseInt(dp) - parseInt(total));
        }
    }

    const ubah_diskon_persen = (event) => {
        const re = /^[+-]?\d*(?:[.]\d*)?$/;
        if (re.test(event.target.value) === false && event.target.value !== "") {
            return;
        }
        setDiskonPersen(event.target.value);
        setDiskon(parseFloat(event.target.value) / 100 * hitung_total());
        // setDiskon(parseInt((event.target.value / 100) * parseInt(total)));
        // setKembalian(parseInt(jumlah_bayar) + parseInt(jumlah_bayar2) + parseInt((event.target.value / 100) * parseInt(total)) + parseInt(dp) - parseInt(total));
    }

    const perbaiki_diskon_persen = (event) => {
        if (event.target.value.trim() === "") {
            setDiskonPersen(0);
            setDiskon(0);
        }
    }

    const simpan = () => {
        if (metode_bayar.trim() === "") {
            setJenisNotif("warning");
            setIsiNotif("Metode bayar wajib diisi");
            setTampilNotif(true);
            document.getElementById("metode_bayar").focus();
            return;
        }

        if (metode_bayar !== "M0" && parseInt(jumlah_bayar) + parseInt(dp) === 0) {
            setJenisNotif("warning");
            setIsiNotif("Jumlah bayar wajib diisi");
            setTampilNotif(true);
            document.getElementById("jumlah_bayar").focus();
            return;
        }

        if (metode_bayar2 !== "M0" && jumlah_metode_bayar === 2 && jumlah_bayar2 === 0) {
            setJenisNotif("warning");
            setIsiNotif("Jumlah bayar Kedua wajib diisi");
            setTampilNotif(true);
            document.getElementById("jumlah_bayar2").focus();
            return;
        }

        if ((metode_bayar !== "M0" && metode_bayar2 != "M0") && jumlah_metode_bayar === 2 && hitung_kembalian() !== 0) {
            setJenisNotif("warning");
            setIsiNotif("Bila menggunakan 2 metode pembayaran, uang harus pas");
            setTampilNotif(true);
            document.getElementById("jumlah_bayar").focus();
            return;
        }

        if (parseFloat(jumlah_bayar) < hitung_ppn()) {
            setJenisNotif("warning");
            setIsiNotif("Jumlah bayar harus lebih besar dari ppn");
            setTampilNotif(true);
            document.getElementById("jumlah_bayar").focus();
            return;
        }

        setProses(true);
        fetch(props.aplikasi + '/kasir/simpan_pembayaran.php',
            {
                method: 'POST',
                body: JSON.stringify
                    ({
                        id_pesanan: id_pesanan,
                        id_metode_bayar: metode_bayar,
                        id_metode_bayar2: metode_bayar2,
                        meja: no_meja,
                        no_telpon: no_telpon,
                        subtotal: hitung_total(),
                        diskon: diskon,
                        ppn: hitung_ppn(),
                        biaya_lainnya: hitung_biaya_lainnya(),
                        pembulatan: hitung_pembulatan(),
                        jumlah_bayar: parseInt(jumlah_bayar) + parseInt(dp),
                        jumlah_bayar2: jumlah_bayar2,
                        kembalian: hitung_kembalian() - parseFloat(hitung_total() * tambah_jual / 100),
                        data_pesanan: data_input_pesanan,
                        id_pengguna: localStorage.getItem("id_pengguna")
                    }),
                headers:
                {
                    "Content-type": "application/json; charset=UTF-8"
                }
            })
            .then(response => response.json())
            .then(data => {
                if (data.kode === 1) {
                    setIdBayar(data.id_pembayaran);
                    setJenisNotif("success");
                    setIsiNotif(data.pesan);
                    setTampilNotif(true);
                    setProses(false);
                }
                else {
                    setJenisNotif("warning");
                    setIsiNotif(data.pesan);
                    setTampilNotif(true);
                    setProses(false);
                }
            })
            .catch(error => {
                setJenisNotif("error");
                setIsiNotif("Terjadi kesalahan");
                setTampilNotif(true);
                setProses(false);
            }
            );
    }

    return (
        <div>
            <Snackbar
                open={tampil_notif}
                autoHideDuration={3000}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                onClose={tutup_notif}
            >
                <Alert
                    severity={jenis_notif}
                    variant="filled"
                    onClose={tutup_notif}
                    sx={{ width: '100%' }}
                >
                    {isi_notif}
                </Alert>
            </Snackbar>

            <Box
                sx={{
                    backgroundColor: "#eff0f0",
                    width: "100%",
                    height: "100%"
                }}
            >
                <Grid container spacing={1} sx={{ padding: "10px" }}>
                    {data_pesanan.map((data_pesanan) => {
                        return (
                            <Grid
                                item xs={6} sm={4} md={3} lg={2}
                                key={data_pesanan.id_pesanan}
                                onClick={() => {
                                    setIdPesanan(data_pesanan.id_pesanan);
                                    setNama(data_pesanan.nama_booking);
                                    setDp(data_pesanan.bayar_booking);
                                    setMetode(data_pesanan.metode);
                                    setNoMeja(data_pesanan.no_meja);
                                    setPelayan(data_pesanan.pelayan);
                                    setWaktuPesan(data_pesanan.waktu_pesan);
                                    setJumlahMetodeBayar(1);
                                    setMetodeBayar("M1");
                                    setMetodeBayar2("");
                                    setTambahJual(0);
                                    setJumlahBayar(0);
                                    setDiskon(0);
                                    tampil_pesanan_detail(data_pesanan.id_pesanan);

                                    fetch(props.aplikasi + '/pengaturan/tampil_pengaturan.php',
                                        {
                                            method: 'GET',
                                            headers:
                                            {
                                                "Content-type": "application/json; charset=UTF-8"
                                            }
                                        })
                                        .then(response => response.json())
                                        .then(data => {
                                            if (data.kode === 1) {
                                                setPpn(data.data[0].ppn);

                                                if (data.data[0].ppn_dine_in === "1") {
                                                    setPpnDineIn(true);
                                                }
                                                else {
                                                    setPpnDineIn(false);
                                                }

                                                if (data.data[0].ppn_take_away === "1") {
                                                    setPpnTakeAway(true);
                                                }
                                                else {
                                                    setPpnTakeAway(false);
                                                }

                                                setTampungBiayaLainnya(data.data[0].biaya_lainnya);
                                                setBiayaLainnya(data.data[0].biaya_lainnya);
                                            }
                                            else {
                                                setPpn(0);
                                                setPpnDineIn(false);
                                                setPpnTakeAway(false);
                                                setTampungBiayaLainnya(0);
                                                setBiayaLainnya(0);
                                            }
                                        })
                                        .catch(error => {
                                            setPpn(0);
                                            setPpnDineIn(false);
                                            setPpnTakeAway(false);
                                            setTampungBiayaLainnya(0);
                                            setBiayaLainnya(0);
                                            setJenisNotif("error");
                                            setIsiNotif("Terjadi kesalahan. Tutup dan buka kembali dialog pembayaran untuk mendapatkan data ppn & biaya lainnya");
                                            setTampilNotif(true);
                                        }
                                        );
                                }}
                            >
                                <Card sx={{ backgroundColor: "#66615b", color: "white" }}>
                                    <List>
                                        <ListItem button>
                                            <ListItemAvatar>
                                                <Avatar
                                                    sx={{
                                                        backgroundColor: switch_warna_metode(data_pesanan.metode)
                                                    }}
                                                >
                                                    {data_pesanan.no_meja !== "" ? data_pesanan.no_meja : null}
                                                </Avatar>
                                            </ListItemAvatar>
                                            <ListItemText
                                                primary={<Typography noWrap variant="subtitle1">{data_pesanan.nama_booking}</Typography>}
                                                secondary={<Typography noWrap variant="body2">{switch_metode(data_pesanan.metode)}</Typography>}
                                            >
                                            </ListItemText>
                                        </ListItem>
                                    </List>
                                </Card>
                            </Grid>
                        );
                    })}
                </Grid>
            </Box>

            <Dialog
                fullScreen
                open={tampil_dialog}
            >
                <Box>
                    <AppBar
                        sx={{
                            display: 'flex'
                        }}
                    >
                        <Toolbar
                            sx={{ backgroundColor: "#fe9400" }}
                        >
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={() => setTampilDialog(false)}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                                Pembayaran
                            </Typography>
                            <LoadingButton autoFocus color="inherit"
                                loadingPosition="start"
                                loading={proses}
                                onClick={() => {
                                    if (data_input_pesanan.length === 0) {
                                        setJenisNotif("warning");
                                        setIsiNotif("Produk belum dipilih");
                                        setTampilNotif(true);
                                        return;
                                    }

                                    if (jumlah_metode_bayar === 2 & metode_bayar2 === "") {
                                        setJenisNotif("warning");
                                        setIsiNotif("Metode bayar kedua belum dipilih");
                                        setTampilNotif(true);
                                        return;
                                    }

                                    setJumlahBayar(0);
                                    setJumlahBayar2(0);
                                    setMetodeDiskon("nominal");
                                    setDiskon(0);
                                    setDiskonPersen(0);
                                    setstatus_biaya_lainnyaBiayaLainnya(false);
                                    setBiayaLainnya(0);
                                    setTampilDialogBayar(true)
                                }}
                            >
                                Bayar
                            </LoadingButton>
                        </Toolbar>
                    </AppBar>

                    <Box sx={{ marginTop: "64px", padding: "10px" }}>
                        {/* <Grid container spacing={1}>
                            <Grid item xs={12} md={6} lg={5}> */}
                        <Card sx={{ padding: "10px" }}>
                            <Typography variant="h6">
                                Data Pemesan
                            </Typography>
                            <Divider />
                            <br />

                            <Grid container spacing={1}>
                                <Grid item xs={2}>
                                    <Typography variant="body2">
                                        Nama
                                    </Typography>
                                </Grid>
                                <Grid item xs={1}>
                                    <Typography variant="body2">
                                        :
                                    </Typography>
                                </Grid>
                                <Grid item xs={9}>
                                    <Typography variant="body2">
                                        {nama}
                                    </Typography>
                                </Grid>
                            </Grid>

                            <Grid container spacing={1}>
                                <Grid item xs={2}>
                                    <Typography variant="body2">
                                        Metode
                                    </Typography>
                                </Grid>
                                <Grid item xs={1}>
                                    <Typography variant="body2">
                                        :
                                    </Typography>
                                </Grid>
                                <Grid item xs={9}>
                                    <Typography variant="body2">
                                        {switch_metode(metode)}
                                    </Typography>
                                </Grid>
                            </Grid>

                            <Grid container spacing={1}>
                                <Grid item xs={2}>
                                    <Typography variant="body2">
                                        No. Meja
                                    </Typography>
                                </Grid>
                                <Grid item xs={1}>
                                    <Typography variant="body2">
                                        :
                                    </Typography>
                                </Grid>
                                <Grid item xs={9}>
                                    <Typography variant="body2">
                                        {no_meja}
                                    </Typography>
                                </Grid>
                            </Grid>

                            <Grid container spacing={1}>
                                <Grid item xs={2}>
                                    <Typography variant="body2">
                                        Pelayan
                                    </Typography>
                                </Grid>
                                <Grid item xs={1}>
                                    <Typography variant="body2">
                                        :
                                    </Typography>
                                </Grid>
                                <Grid item xs={9}>
                                    <Typography variant="body2">
                                        {pelayan}
                                    </Typography>
                                </Grid>
                            </Grid>

                            <Grid container spacing={1}>
                                <Grid item xs={2}>
                                    <Typography variant="body2">
                                        Waktu Pesan
                                    </Typography>
                                </Grid>
                                <Grid item xs={1}>
                                    <Typography variant="body2">
                                        :
                                    </Typography>
                                </Grid>
                                <Grid item xs={9}>
                                    <Typography variant="body2">
                                        {waktu_pesan}
                                    </Typography>
                                </Grid>
                            </Grid>

                            <Grid container item>
                                <Grid item xs={2}>
                                    <Typography variant="body2">
                                        No. Telpon
                                    </Typography>
                                </Grid>
                                <Grid item xs={1}>
                                    <Typography variant="body2">
                                        :
                                    </Typography>
                                </Grid>
                                <Grid container item spacing={1} xs={9}>
                                    <Grid item xs={6}>
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            sx={{ marginBottom: "15px" }}
                                            value={no_telpon}
                                            onChange={(e) => ubah_no_telpon(e)}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid container item>
                                <Grid item xs={2}>
                                    <Typography variant="body2">
                                        Metode Bayar
                                    </Typography>
                                </Grid>

                                <Grid item xs={1}>
                                    <Typography variant="body2">
                                        :
                                    </Typography>
                                </Grid>

                                <Grid container item spacing={1} xs={9}>
                                    <Grid item xs={6}>
                                        <FormControl size="small" fullWidth>
                                            <Select
                                                id="metode_bayar"
                                                variant="outlined"
                                                fullWidth
                                                disabled={dp > 0 ? true : false}
                                                value={metode_bayar}
                                                onChange={(event) => {
                                                    if (jumlah_metode_bayar === 2) {
                                                        if (event.target.value === metode_bayar2) {
                                                            setJenisNotif("warning");
                                                            setIsiNotif("Metode bayar harus berbeda");
                                                            setTampilNotif(true);
                                                            return;
                                                        }

                                                        var awal = 1;
                                                        var akhir = data_metode_bayar.length;
                                                        while (awal <= akhir) {
                                                            if (data_metode_bayar[awal - 1]["id_metode"] === event.target.value) {
                                                                if (parseFloat(data_metode_bayar[awal - 1]["tambah_hpp"]) > 0 || parseFloat(data_metode_bayar[awal - 1]["tambah_jual"]) > 0) {
                                                                    setJenisNotif("warning");
                                                                    setIsiNotif("Tidak dapat menambah metode bayar karena terdapat metode bayar dengan penambahan nilai jual");
                                                                    setTampilNotif(true);
                                                                    return;
                                                                }
                                                                break;
                                                            }
                                                            awal++;
                                                        }
                                                    }

                                                    awal = 1;
                                                    akhir = data_metode_bayar.length;
                                                    while (awal <= akhir) {
                                                        if (event.target.value === data_metode_bayar[awal - 1].id_metode) {
                                                            setTambahJual(data_metode_bayar[awal - 1].tambah_jual);
                                                            break;
                                                        }
                                                        awal++;
                                                    }

                                                    setMetodeBayar(event.target.value);
                                                }}
                                            >
                                                {data_metode_bayar.map((data_metode_bayar) => {
                                                    return (
                                                        <MenuItem key={data_metode_bayar.id_metode} value={data_metode_bayar.id_metode}>{data_metode_bayar.nama}</MenuItem>
                                                    )
                                                })}
                                            </Select>
                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={12}>
                                        <Link
                                            component="button"
                                            display={jumlah_metode_bayar === 1 ? "" : "none"}
                                            onClick={() => {
                                                var awal = 1;
                                                var akhir = data_metode_bayar.length;
                                                while (awal <= akhir) {
                                                    if (data_metode_bayar[awal - 1]["id_metode"] === metode_bayar) {
                                                        if (parseFloat(data_metode_bayar[awal - 1]["tambah_hpp"]) > 0 || parseFloat(data_metode_bayar[awal - 1]["tambah_jual"]) > 0) {
                                                            setJenisNotif("warning");
                                                            setIsiNotif("Tidak dapat menambah metode bayar karena terdapat metode bayar dengan penambahan nilai jual");
                                                            setTampilNotif(true);
                                                            return;
                                                        }
                                                        break;
                                                    }
                                                    awal++;
                                                }

                                                if (jumlah_metode_bayar === 1) {
                                                    setJumlahMetodeBayar(2);
                                                }
                                                else {
                                                    setJumlahMetodeBayar(1);
                                                }
                                            }}
                                        >
                                            Tambah metode bayar
                                        </Link>
                                    </Grid>

                                    <Grid item xs={6} display={jumlah_metode_bayar === 1 ? "none" : ""}>
                                        <FormControl size="small" fullWidth>
                                            <Select
                                                id="metode_bayar2"
                                                variant="outlined"
                                                fullWidth
                                                value={metode_bayar2}
                                                onChange={(event) => {
                                                    if (event.target.value === metode_bayar) {
                                                        setJenisNotif("warning");
                                                        setIsiNotif("Metode bayar harus berbeda");
                                                        setTampilNotif(true);
                                                        return;
                                                    }

                                                    var awal = 1;
                                                    var akhir = data_metode_bayar.length;
                                                    while (awal <= akhir) {
                                                        if (data_metode_bayar[awal - 1]["id_metode"] === event.target.value) {
                                                            if (parseFloat(data_metode_bayar[awal - 1]["tambah_hpp"]) > 0 || parseFloat(data_metode_bayar[awal - 1]["tambah_jual"]) > 0) {
                                                                setJenisNotif("warning");
                                                                setIsiNotif("Tidak dapat menambah metode bayar karena terdapat metode bayar dengan penambahan nilai jual");
                                                                setTampilNotif(true);
                                                                return;
                                                            }
                                                            break;
                                                        }
                                                        awal++;
                                                    }

                                                    setMetodeBayar2(event.target.value);
                                                }}
                                            >
                                                <MenuItem value="">Pilih Metode Bayar Kedua</MenuItem>
                                                {data_metode_bayar.map((data_metode_bayar) => {
                                                    return (
                                                        <MenuItem key={data_metode_bayar.id_metode} value={data_metode_bayar.id_metode}>{data_metode_bayar.nama}</MenuItem>
                                                    )
                                                })}
                                            </Select>
                                        </FormControl>

                                        <Link
                                            component="button"
                                            display={jumlah_metode_bayar === 1 ? "none" : ""}
                                            onClick={() => {
                                                if (jumlah_metode_bayar === 1) {
                                                    setJumlahMetodeBayar(2);
                                                }
                                                else {
                                                    setJumlahMetodeBayar(1);
                                                }

                                                setMetodeBayar2("");
                                            }}
                                        >
                                            Hapus metode bayar
                                        </Link>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Card>
                        {/* </Grid> */}
                        <br />
                        {/* <Grid item xs={12} md={6} lg={7}> */}
                        <Card sx={{ padding: "10px" }}>
                            <Typography variant="h6">
                                Daftar Pesanan
                            </Typography>
                            <Divider />
                            <br />

                            <LoadingButton
                                loadingPosition="start"
                                loading={proses}
                                variant="contained"
                                color="primary"
                                startIcon={<AddIcon />}
                                sx={{ marginRight: "5px", marginTop: "5px", borderRadius: "5em", backgroundColor: "#37ce9b", border: "#37ce9b" }}
                                onClick={async () => {
                                    const proses_jenis = await tampil_jenis();
                                    const proses_produk = await tampil_produk(proses_jenis[0].id_jenis, 1);
                                    setDataJenis(proses_jenis);
                                    setJenis(proses_jenis[0].id_jenis);
                                    setDataProduk(proses_produk);
                                    setTampilDialogProduk(true);
                                }}
                            >
                                Tambah Item
                            </LoadingButton>
                            <br /><br />

                            <TableContainer component={Paper}>
                                <Table stickyHeader size="small" aria-label="sticky table">
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell align="center">Nama</StyledTableCell>
                                            <StyledTableCell align="center">Harga</StyledTableCell>
                                            <StyledTableCell align="center">Diskon</StyledTableCell>
                                            <StyledTableCell align="center">Jumlah</StyledTableCell>
                                            <StyledTableCell align="center">Subtotal</StyledTableCell>
                                            <StyledTableCell align="center">Aksi</StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {data_input_pesanan.map((data_input_pesanan, index) => {
                                            return (
                                                <StyledTableRow key={data_input_pesanan.id_produk}>
                                                    <TableCell size="small"><Typography variant="body2" noWrap={true}>{data_input_pesanan.nama}</Typography></TableCell>
                                                    <TableCell size="small" align="right"><Typography variant="body2" noWrap={true}>
                                                        {/* {format_rupiah(parseFloat(data_input_pesanan.harga) + parseFloat(data_input_pesanan.harga * tambah_jual / 100))} */}
                                                        {format_rupiah(parseFloat(data_input_pesanan.harga))}
                                                    </Typography></TableCell>
                                                    <TableCell size="small" align="right"><Typography variant="body2" noWrap={true} sx={{ color: "green" }}>
                                                        {/* {parseFloat(data_input_pesanan.diskon_nominal) !== 0 && data_input_pesanan.diskon_nominal !== undefined ? "-" + format_rupiah(parseFloat(data_input_pesanan.diskon_nominal)) : ""} */}
                                                        {parseFloat(data_input_pesanan.diskon_nominal) !== 0 ? "-" : ""} {format_rupiah(parseFloat(data_input_pesanan.diskon_nominal))}
                                                    </Typography></TableCell>
                                                    <TableCell size="small" align="center" sx={{ whiteSpace: "nowrap" }}>
                                                        <Fab
                                                            color="primary"
                                                            size="small"
                                                            style={{ backgroundColor: "gray" }}
                                                            // onClick={() => kurang_pesanan(data_input_pesanan.id_produk, data_input_pesanan.jumlah_minimal, data_input_pesanan.no_tambahan)}
                                                            onClick={() => kurang_pesanan(index)}
                                                        >
                                                            <RemoveIcon />
                                                        </Fab>
                                                        <TextField
                                                            variant="outlined"
                                                            size="small"
                                                            inputProps={{
                                                                style: { textAlign: "center", width: "50px" }
                                                            }}
                                                            value={data_input_pesanan.jumlah}
                                                            // onChange={(e) => ubah_jumlah_pesanan(e, data_input_pesanan.id_produk, data_input_pesanan.no_tambahan)}
                                                            // onBlur={(e) => perbaiki_pesanan(e, data_input_pesanan.id_produk, data_input_pesanan.jumlah_minimal, data_input_pesanan.no_tambahan)}
                                                            onChange={(e) => ubah_jumlah_pesanan(e, index)}
                                                            onBlur={(e) => perbaiki_pesanan(e, index)}
                                                        />
                                                        <Fab
                                                            color="primary"
                                                            size="small"
                                                            style={{ backgroundColor: "gray" }}
                                                            // onClick={() => tambah_pesanan(data_input_pesanan.id_produk, data_input_pesanan.no_tambahan)}
                                                            onClick={() => tambah_pesanan(index)}
                                                        >
                                                            <AddIcon />
                                                        </Fab>
                                                    </TableCell>
                                                    {/* <TableCell size="small" align="right"><Typography variant="body2" noWrap={true}>{format_rupiah((parseFloat(data_input_pesanan.harga) + parseFloat(data_input_pesanan.harga * tambah_jual / 100)) * parseFloat(data_input_pesanan.jumlah))}</Typography></TableCell> */}
                                                    {/* <TableCell size="small" align="right"><Typography variant="body2" noWrap={true}>{data_input_pesanan.subtotal2}</Typography></TableCell> */}
                                                    <TableCell size="small" align="right">
                                                        <Typography variant="body2" noWrap={true}>
                                                            {format_rupiah(parseFloat(data_input_pesanan.jumlah) * (parseFloat(data_input_pesanan.harga) - parseFloat(data_input_pesanan.diskon_nominal)))}
                                                        </Typography>
                                                        <Typography variant="caption" noWrap={true}
                                                            sx={
                                                                parseFloat(tambah_jual) === 0 ? { display: "none", color: "red" } : { color: "red" }
                                                            }
                                                        >
                                                            +{format_rupiah(parseFloat(data_input_pesanan.jumlah) * (parseFloat(data_input_pesanan.harga) - parseFloat(data_input_pesanan.diskon_nominal)) * parseFloat(tambah_jual) / 100)}
                                                        </Typography>
                                                    </TableCell>
                                                    <TableCell size="small" align="center">
                                                        <Fab
                                                            color="primary"
                                                            size="small"
                                                            style={data_input_pesanan.tambahan === "1" ? { backgroundColor: "red" } : { display: "none" }}
                                                            // onClick={() => hapus_pesanan(data_input_pesanan.id_produk)}
                                                            onClick={() => hapus_pesanan(index)}
                                                        >
                                                            <DeleteIcon />
                                                        </Fab>
                                                    </TableCell>
                                                </StyledTableRow>
                                            );
                                        })}

                                        <TableRow>
                                            <TableCell align="right" colSpan={4}>
                                                <Typography variant="h6">
                                                    Total
                                                </Typography>
                                            </TableCell>
                                            <TableCell align="right">
                                                <Typography variant="h6" noWrap={true} sx={{ color: "red" }}>
                                                    {format_rupiah(hitung_total() + parseFloat(hitung_total() * tambah_jual / 100))}
                                                </Typography>
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Card>
                        {/* </Grid>
                        </Grid> */}
                    </Box>
                </Box>
            </Dialog>

            {/* <Dialog
                open={tampil_dialog_bayar}
            >
                <DialogTitle>Pembayaran</DialogTitle>

                <DialogContent>
                    <DialogContentText>
                        <Grid container item spacing={1}>
                            <Grid container item>
                                <Grid item xs={4} sm={4} md={3}>

                                </Grid>

                                <Grid container item spacing={1} xs={8} sm={8} md={9}>
                                    <Grid item xs={6}>
                                        <Typography variant="body2" align="right">
                                            Tagihan
                                        </Typography>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <Typography variant="h4" align="right" sx={{ color: "red" }}>
                                            Rp. {format_rupiah(total + parseFloat(total * tambah_jual / 100))}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid container item>
                                <Grid item xs={4} sm={4} md={3}>

                                </Grid>

                                <Grid container item spacing={1} xs={8} sm={8} md={9}>
                                    <Grid item xs={6}>
                                        <Typography variant="body2" align="right">
                                            DP
                                        </Typography>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <Typography variant="h6" align="right" sx={{ color: "green" }}>
                                            - Rp. {format_rupiah(parseFloat(dp))}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid container item>
                                <Grid item xs={4} sm={4} md={3}>
                                    <Typography variant="body2">
                                        Jumlah Bayar
                                    </Typography>
                                </Grid>

                                <Grid container item spacing={1} xs={8} sm={8} md={9}>
                                    <Grid item xs={6}>
                                        <TextField
                                            id="jumlah_bayar"
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            multiline
                                            disabled={metode_bayar === "M0" ? true : false}
                                            value={jumlah_bayar}
                                            onChange={(e) => ubah_jumlah_bayar(e)}
                                            onBlur={(e) => perbaiki_jumlah_bayar(e)}
                                        />
                                    </Grid>

                                    <Grid item xs={6}>
                                        <Typography variant="h6" align="right" sx={{ color: "green" }}>
                                            Rp. {format_rupiah(parseInt(jumlah_bayar))}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid container item
                                display={jumlah_metode_bayar === 2 ? "" : "none"}
                            >
                                <Grid item xs={4} sm={4} md={3}>
                                    <Typography variant="body2">
                                        Jumlah Bayar Kedua
                                    </Typography>
                                </Grid>

                                <Grid container item spacing={1} xs={8} sm={8} md={9}>
                                    <Grid item xs={6}>
                                        <TextField
                                            id="jumlah_bayar2"
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            multiline
                                            disabled={metode_bayar2 === "M0" ? true : false}
                                            value={jumlah_bayar2}
                                            onChange={(e) => ubah_jumlah_bayar2(e)}
                                            onBlur={(e) => perbaiki_jumlah_bayar2(e)}
                                        />
                                    </Grid>

                                    <Grid item xs={6}>
                                        <Typography variant="h6" align="right" sx={{ color: "green" }}>
                                            Rp. {format_rupiah(parseInt(jumlah_bayar2))}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid container item>
                                <Grid item xs={4} sm={4} md={3}>
                                    <Typography variant="body2">
                                        Diskon
                                    </Typography>
                                </Grid>

                                <Grid container item spacing={1} xs={8} sm={8} md={9}>
                                    <Grid container spacing={1} item xs={6}>
                                        <Grid
                                            item xs={12}
                                        >
                                            <ButtonGroup variant="contained" aria-label="outlined primary button group">
                                                <LoadingButton
                                                    loadingPosition="start"
                                                    loading={proses}
                                                    variant={metode_diskon === "nominal" ? "contained" : "outlined"}
                                                    onClick={() => {
                                                        setMetodeDiskon("nominal");
                                                        setDiskon(0);
                                                        setDiskonPersen(0);
                                                        setKembalian(parseInt(jumlah_bayar) + parseInt(jumlah_bayar2) + parseInt(0) + parseInt(dp) - parseInt(total));
                                                    }}
                                                >
                                                    Rp.
                                                </LoadingButton>
                                                <LoadingButton
                                                    loadingPosition="start"
                                                    loading={proses}
                                                    variant={metode_diskon !== "nominal" ? "contained" : "outlined"}
                                                    onClick={() => {
                                                        setMetodeDiskon("persen");
                                                        setDiskon(0);
                                                        setDiskonPersen(0);
                                                        setKembalian(parseInt(jumlah_bayar) + parseInt(jumlah_bayar2) + parseInt(0) + parseInt(dp) - parseInt(total));
                                                    }}
                                                >
                                                    %
                                                </LoadingButton>
                                            </ButtonGroup>
                                        </Grid>

                                        <Grid
                                            item xs={12}
                                            sx={
                                                metode_diskon === "nominal" ? { display: "none" } : { display: "" }
                                            }
                                        >
                                            <TextField
                                                variant="outlined"
                                                size="small"
                                                fullWidth
                                                multiline
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            %
                                                        </InputAdornment>
                                                    ),
                                                }}
                                                value={diskon_persen}
                                                onChange={(e) => ubah_diskon_persen(e)}
                                                onBlur={(e) => perbaiki_diskon_persen(e)}
                                            />
                                        </Grid>

                                        <Grid
                                            item xs={12}
                                        >
                                            <TextField
                                                variant="outlined"
                                                size="small"
                                                fullWidth
                                                multiline
                                                disabled={metode_diskon === "nominal" ? false : true}
                                                value={diskon}
                                                onChange={(e) => ubah_diskon(e)}
                                                onBlur={(e) => perbaiki_diskon(e)}
                                            />
                                        </Grid>
                                    </Grid>

                                    <Grid container item xs={6}>
                                        <Grid
                                            item xs={12}
                                        >
                                            <Typography variant="h6" align="right" sx={{ color: "white" }}>
                                                Rp. {format_rupiah(parseInt(diskon))}
                                            </Typography>
                                        </Grid>

                                        <Grid
                                            item xs={12}
                                        >
                                            <Typography variant="h6" align="right" sx={{ color: "white" }}>
                                                Rp. {format_rupiah(parseInt(diskon))}
                                            </Typography>
                                        </Grid>

                                        <Grid
                                            item xs={12}
                                        >
                                            <Typography variant="h6" align="right" sx={{ color: "green" }}>
                                                Rp. {format_rupiah(parseInt(diskon))}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid container item>
                                <Grid item xs={4} sm={4} md={3}>

                                </Grid>

                                <Grid container item spacing={1} xs={8} sm={8} md={9}>
                                    <Grid item xs={6}>
                                        <Typography variant="body2" align="right">
                                            Kembalian
                                        </Typography>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <Typography variant="h6" align="right" sx={{ color: "red" }}>
                                            Rp. {format_rupiah(kembalian - parseFloat(total * tambah_jual / 100))}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </DialogContentText>
                </DialogContent>

                <DialogActions>
                    <LoadingButton
                        loadingPosition="start"
                        loading={proses}
                        variant="contained"
                        color="primary"
                        startIcon={<PrintIcon />}
                        sx={
                            id_bayar !== ""
                                ? { marginRight: "5px", marginTop: "5px", borderRadius: "5em", backgroundColor: "#8080FF" }
                                : { display: "none" }
                        }
                        onClick={() =>
                            window.open(props.aplikasi + '/kasir/cetak_pembayaran.php?id_bayar=' + id_bayar)
                        }
                    >
                        Cetak
                    </LoadingButton>

                    <LoadingButton
                        loadingPosition="start"
                        loading={proses}
                        variant="contained"
                        color="primary"
                        startIcon={<AttachMoneyIcon />}
                        sx={
                            id_bayar === ""
                                ? { marginRight: "5px", marginTop: "5px", borderRadius: "5em" }
                                : { display: "none" }
                        }
                        onClick={() => simpan()}
                    >
                        Bayar
                    </LoadingButton>

                    <LoadingButton
                        loadingPosition="start"
                        loading={proses}
                        variant="contained"
                        color="primary"
                        startIcon={<CloseIcon />}
                        sx={{ marginRight: "5px", marginTop: "5px", borderRadius: "5em", backgroundColor: "#555555" }}
                        onClick={() => {
                            if (id_bayar !== "") {
                                setIdBayar("");
                                // setMetodeBayar("");
                                setJumlahBayar(0);
                                setJumlahBayar2(0);
                                setMetodeDiskon("nominal");
                                setDiskonPersen(0);
                                setDiskon(0);
                                setTampilDialog(false);
                                tampil_pesanan();
                            }
                            setTampilDialogBayar(false);
                        }}
                    >
                        Tutup
                    </LoadingButton>
                </DialogActions>
            </Dialog> */}

            <Dialog
                open={tampil_dialog_bayar}
                maxWidth="md"
            >
                <DialogTitle>Pembayaran</DialogTitle>

                <DialogContent>
                    <DialogContentText>
                        <Grid container item spacing={1}>
                            <Grid container item>
                                <Grid item xs={4} sm={4} md={3}>

                                </Grid>

                                <Grid container item spacing={1} xs={8} sm={8} md={9}>
                                    <Grid item xs={6}>
                                        <Typography variant="body2" align="right">
                                            Subtotal
                                        </Typography>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <Typography variant="h6" align="right" sx={{ color: "green" }}>
                                            Rp. {format_rupiah(parseFloat(hitung_total()))}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid container item>
                                <Grid item xs={4} sm={4} md={3}>
                                    <Typography variant="body2">
                                        Diskon
                                    </Typography>
                                </Grid>

                                <Grid container item spacing={1} xs={8} sm={8} md={9}>
                                    <Grid container spacing={1} item xs={6}>
                                        <Grid
                                            item xs={12}
                                        >
                                            <ButtonGroup variant="contained" aria-label="outlined primary button group">
                                                <LoadingButton
                                                    loadingPosition="start"
                                                    loading={proses}
                                                    variant={metode_diskon === "nominal" ? "contained" : "outlined"}
                                                    onClick={() => {
                                                        setMetodeDiskon("nominal");
                                                        setDiskon(0);
                                                        setDiskonPersen(0);
                                                        // setKembalian(parseFloat(jumlah_bayar) + parseFloat(jumlah_bayar2) + parseFloat(0) + parseFloat(dp) - parseFloat(total));
                                                    }}
                                                >
                                                    Rp.
                                                </LoadingButton>
                                                <LoadingButton
                                                    loadingPosition="start"
                                                    loading={proses}
                                                    variant={metode_diskon !== "nominal" ? "contained" : "outlined"}
                                                    onClick={() => {
                                                        setMetodeDiskon("persen");
                                                        setDiskon(0);
                                                        setDiskonPersen(0);
                                                        // setKembalian(parseFloat(jumlah_bayar) + parseFloat(jumlah_bayar2) + parseFloat(0) + parseFloat(dp) - parseFloat(total));
                                                    }}
                                                >
                                                    %
                                                </LoadingButton>
                                            </ButtonGroup>
                                        </Grid>

                                        <Grid
                                            item xs={12}
                                            sx={
                                                metode_diskon === "nominal" ? { display: "none" } : { display: "" }
                                            }
                                        >
                                            <TextField
                                                variant="outlined"
                                                size="small"
                                                fullWidth
                                                multiline
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            %
                                                        </InputAdornment>
                                                    ),
                                                }}
                                                value={diskon_persen}
                                                onChange={(e) => ubah_diskon_persen(e)}
                                                onBlur={(e) => perbaiki_diskon_persen(e)}
                                            />
                                        </Grid>

                                        <Grid
                                            item xs={12}
                                        >
                                            <TextField
                                                variant="outlined"
                                                size="small"
                                                fullWidth
                                                multiline
                                                disabled={metode_diskon === "nominal" ? false : true}
                                                value={diskon}
                                                onChange={(e) => ubah_diskon(e)}
                                                onBlur={(e) => perbaiki_diskon(e)}
                                            />
                                        </Grid>
                                    </Grid>

                                    <Grid container item xs={6}>
                                        <Grid
                                            item xs={12}
                                        >
                                            <Typography variant="h6" align="right" sx={{ color: "white" }}>
                                                Rp. {format_rupiah(parseFloat(diskon))}
                                            </Typography>
                                        </Grid>

                                        <Grid
                                            item xs={12}
                                        >
                                            <Typography variant="h6" align="right" sx={{ color: "white" }}>
                                                Rp. {format_rupiah(parseFloat(diskon))}
                                            </Typography>
                                        </Grid>

                                        <Grid
                                            item xs={12}
                                        >
                                            <Typography variant="h6" align="right" sx={{ color: "green" }}>
                                                Rp. {format_rupiah(parseFloat(diskon))}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item xs={12}>
                                <Divider />
                            </Grid>

                            <Grid container item>
                                <Grid item xs={4} sm={4} md={3}>

                                </Grid>

                                <Grid container item spacing={1} xs={8} sm={8} md={9}>
                                    <Grid item xs={6}>
                                        <Typography variant="body2" align="right">
                                            Total
                                        </Typography>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <Typography variant="h6" align="right" sx={{ color: "green" }}>
                                            Rp. {format_rupiah(parseFloat(hitung_total()) - parseFloat(diskon))}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid container item>
                                <Grid item xs={4} sm={4} md={3}>

                                </Grid>

                                <Grid container item spacing={1} xs={8} sm={8} md={9}>
                                    <Grid item xs={6}>
                                        <Typography variant="body2" align="right">
                                            PPN ({ppn}%)
                                        </Typography>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <Typography variant="body2" align="right" sx={{ color: "red" }}>
                                            Rp. {format_rupiah(hitung_ppn())}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid container item>
                                <Grid item xs={4} sm={4} md={3}>

                                </Grid>

                                <Grid container item spacing={1} xs={8} sm={8} md={9}>
                                    <Grid item xs={6}>
                                        <Stack direction="row" spacing={1}
                                            sx={{
                                                justifyContent: "flex-end",
                                                alignItems: "center",
                                            }}
                                        >
                                            <Switch
                                                checked={status_biaya_lainnya}
                                                onChange={(event) => {
                                                    if (status_biaya_lainnya === false) {
                                                        setstatus_biaya_lainnyaBiayaLainnya(true);
                                                        setBiayaLainnya(tampung_biaya_lainnya);;
                                                    }
                                                    else {
                                                        setstatus_biaya_lainnyaBiayaLainnya(false);
                                                        setBiayaLainnya(0);
                                                    }
                                                }}
                                            />

                                            <Typography variant="body2" align="right">
                                                Service Charge ({biaya_lainnya}%)
                                            </Typography>
                                        </Stack>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <Typography variant="body2" align="right" sx={{ color: "red" }}>
                                            Rp. {format_rupiah(hitung_biaya_lainnya())}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item xs={12}>
                                <Divider />
                            </Grid>

                            <Grid container item>
                                <Grid item xs={4} sm={4} md={3}>

                                </Grid>

                                <Grid container item spacing={1} xs={8} sm={8} md={9}>
                                    <Grid item xs={6} />

                                    <Grid item xs={6}>
                                        <Typography variant="body2" align="right" sx={{ color: "red" }}>
                                            Rp. {format_rupiah(parseFloat(hitung_total()) - parseFloat(diskon) + hitung_ppn() + hitung_biaya_lainnya())}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid container item>
                                <Grid item xs={4} sm={4} md={3}>

                                </Grid>

                                <Grid container item spacing={1} xs={8} sm={8} md={9}>
                                    <Grid item xs={6}>
                                        <Typography variant="body2" align="right">
                                            Pembulatan
                                        </Typography>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <Typography variant="body2" align="right" sx={{ color: "red" }}>
                                            Rp. {format_rupiah(hitung_pembulatan())}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid container item>
                                <Grid item xs={4} sm={4} md={3}>

                                </Grid>

                                <Grid container item spacing={1} xs={8} sm={8} md={9}>
                                    <Grid item xs={6}>
                                        <Typography variant="body2" align="right">
                                            Tagihan
                                        </Typography>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <Typography variant="h4" align="right" sx={{ color: "red" }}>
                                            Rp. {format_rupiah(parseFloat(hitung_total()) - parseFloat(diskon) + hitung_ppn() + hitung_biaya_lainnya() + hitung_pembulatan())}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid container item>
                                <Grid item xs={4} sm={4} md={3}>
                                    <Typography variant="body2">
                                        Jumlah Bayar
                                    </Typography>
                                </Grid>

                                <Grid container item spacing={1} xs={8} sm={8} md={9}>
                                    <Grid item xs={6}>
                                        <TextField
                                            id="jumlah_bayar"
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            multiline
                                            disabled={metode_bayar === "M0" ? true : false}
                                            value={jumlah_bayar}
                                            onChange={(e) => ubah_jumlah_bayar(e)}
                                            onBlur={(e) => perbaiki_jumlah_bayar(e)}
                                        />
                                    </Grid>

                                    <Grid item xs={6}>
                                        <Typography variant="h6" align="right" sx={{ color: "green" }}>
                                            Rp. {format_rupiah(parseFloat(jumlah_bayar))}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid container item
                                display={jumlah_metode_bayar === 2 ? "" : "none"}
                            >
                                <Grid item xs={4} sm={4} md={3}>
                                    <Typography variant="body2">
                                        Jumlah Bayar Kedua
                                    </Typography>
                                </Grid>

                                <Grid container item spacing={1} xs={8} sm={8} md={9}>
                                    <Grid item xs={6}>
                                        <TextField
                                            id="jumlah_bayar2"
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            multiline
                                            disabled={metode_bayar2 === "M0" ? true : false}
                                            value={jumlah_bayar2}
                                            onChange={(e) => ubah_jumlah_bayar2(e)}
                                            onBlur={(e) => perbaiki_jumlah_bayar2(e)}
                                        />
                                    </Grid>

                                    <Grid item xs={6}>
                                        <Typography variant="h6" align="right" sx={{ color: "green" }}>
                                            Rp. {format_rupiah(parseFloat(jumlah_bayar2))}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid container item>
                                <Grid item xs={4} sm={4} md={3}>

                                </Grid>

                                <Grid container item spacing={1} xs={8} sm={8} md={9}>
                                    <Grid item xs={6}>
                                        <Typography variant="body2" align="right">
                                            Kembalian
                                        </Typography>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <Typography variant="h6" align="right" sx={{ color: "red" }}>
                                            {/* Rp. {format_rupiah(kembalian - parseFloat(total * tambah_jual / 100))} */}
                                            Rp. {format_rupiah(hitung_kembalian())}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </DialogContentText>
                </DialogContent>

                <DialogActions>
                    <LoadingButton
                        loadingPosition="start"
                        loading={proses}
                        variant="contained"
                        color="primary"
                        startIcon={<PrintIcon />}
                        sx={
                            id_bayar !== ""
                                ? { marginRight: "5px", marginTop: "5px", borderRadius: "5em", backgroundColor: "#8080FF" }
                                : { display: "none" }
                        }
                        onClick={() =>
                            window.open(props.aplikasi + '/kasir/cetak_pembayaran.php?id_bayar=' + id_bayar)
                        }
                    >
                        Cetak
                    </LoadingButton>

                    <LoadingButton
                        loadingPosition="start"
                        loading={proses}
                        variant="contained"
                        color="primary"
                        startIcon={<AttachMoneyIcon />}
                        sx={
                            id_bayar === ""
                                ? { marginRight: "5px", marginTop: "5px", borderRadius: "5em" }
                                : { display: "none" }
                        }
                        // onClick={() => {
                        //     if (id_pesanan === "") {
                        //         simpan();
                        //     }
                        //     else {
                        //         simpan_penyelesaian_pembayaran();
                        //     }
                        // }}
                        onClick={() => simpan()}
                    >
                        Bayar
                    </LoadingButton>

                    <LoadingButton
                        loadingPosition="start"
                        loading={proses}
                        variant="contained"
                        color="primary"
                        startIcon={<CloseIcon />}
                        sx={{ marginRight: "5px", marginTop: "5px", borderRadius: "5em", backgroundColor: "#555555" }}
                        onClick={() => {
                            if (id_bayar !== "") {
                                setIdBayar("");
                                // setMetodeBayar("");
                                setJumlahBayar(0);
                                setJumlahBayar2(0);
                                setMetodeDiskon("nominal");
                                setDiskonPersen(0);
                                setDiskon(0);
                                setTampilDialog(false);
                                tampil_pesanan();
                            }
                            setTampilDialogBayar(false);

                            // if (id_bayar !== "") {
                            //     setIdBayar("");
                            //     tampil_pesanan();
                            //     setTampilDialog(false);
                            //     setTampilDialogTambahMenu(false);
                            //     setTampilDialogBayarTambahan(false);
                            // }

                            // setTampilDialogBayar(false);
                        }}
                    >
                        Tutup
                    </LoadingButton>
                </DialogActions>
            </Dialog>

            <Dialog
                fullScreen
                open={tampil_dialog_produk}
            >
                <Box sx={{ height: "calc(100% - 90px)" }}>
                    <AppBar
                        sx={{
                            display: 'flex'
                        }}
                    >
                        <Toolbar
                            sx={{ backgroundColor: "#fe9400" }}
                        >
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={() => setTampilDialogProduk(false)}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                                Pilih Menu
                            </Typography>
                        </Toolbar>
                    </AppBar>

                    <Box sx={{ borderBottom: 1, borderColor: 'divider', marginTop: "64px" }}>
                        <Tabs
                            centered
                            value={jenis}
                            onChange={(event, value) => ubah_jenis_produk(value)}
                        >
                            {data_jenis.map((data_jenis) => {
                                return (
                                    <Tab key={data_jenis.id_jenis} value={data_jenis.id_jenis} label={data_jenis.nama} />
                                )
                            })}
                        </Tabs>
                    </Box>

                    <Box>
                        <Grid container spacing={1} sx={{ padding: "10px" }}>
                            {/* <Grid container item spacing={1} xs={12} lg={7}>
                                {data_produk.map((data_produk) => {
                                    return (
                                        <Grid
                                            key={data_produk.id_produk}
                                            sx={{ margin: "10px", width: "150px" }}
                                            onClick={() => {
                                                var tampung = [];
                                                var awal, akhir = 0;
                                                if (data_input_pesanan.length > 0) {
                                                    tampung = data_input_pesanan;
                                                    awal = 1;
                                                    akhir = tampung.length;
                                                    var cari = "";
                                                    while (awal <= akhir) {
                                                        if (tampung[awal - 1]["id_produk"] === data_produk.id_produk) {
                                                            tampung[awal - 1]["jumlah"] = parseInt(tampung[awal - 1]["jumlah"]) + 1;
                                                            tampung[awal - 1]["subtotal"] = parseInt(tampung[awal - 1]["jumlah"]) * parseInt(tampung[awal - 1]["harga"]);
                                                            tampung[awal - 1]["subtotal2"] = format_rupiah(tampung[awal - 1]["subtotal"]);
                                                            cari = "ada";
                                                            break;
                                                        }
                                                        awal++;
                                                    }

                                                    if (cari === "") {
                                                        tampung.push({ "id_jenis": data_produk.id_jenis, "jenis": data_produk.jenis, "id_produk": data_produk.id_produk, "nama": data_produk.nama, "hpp": data_produk.hpp, "jumlah": 1, "harga": data_produk.harga, "harga2": data_produk.harga2, "subtotal": data_produk.harga, "subtotal2": data_produk.harga2, "tambahan": "1" });
                                                    }
                                                }
                                                else {
                                                    tampung.push({ "id_jenis": data_produk.id_jenis, "jenis": data_produk.jenis, "id_produk": data_produk.id_produk, "nama": data_produk.nama, "hpp": data_produk.hpp, "jumlah": 1, "harga": data_produk.harga, "harga2": data_produk.harga2, "subtotal": data_produk.harga, "subtotal2": data_produk.harga2, "tambahan": "1" });
                                                }

                                                var total = 0;
                                                awal = 1;
                                                akhir = tampung.length;
                                                while (awal <= akhir) {
                                                    total = total + parseFloat(tampung[awal - 1]["subtotal"]);
                                                    awal++;
                                                }

                                                setDataInputPesanan(tampung);
                                                setTotal(total);
                                            }}
                                        >
                                            <Card>
                                                <ImageListItem>
                                                    <CardMedia
                                                        component="img"
                                                        src={props.file + "/Foto/Produk/" + data_produk.foto}
                                                        sx={{
                                                            backgroundColor: "gray",
                                                            width: "150px",
                                                            height: "150px"
                                                        }}
                                                    />
                                                    <ImageListItemBar
                                                        title={data_produk.nama}
                                                        subtitle={"Rp. " + data_produk.harga2}
                                                    />
                                                </ImageListItem>
                                            </Card>
                                        </Grid>
                                    );
                                })}
                            </Grid> */}

                            <Grid item xs={12} md={5}>
                                <Card sx={{ padding: "10px" }}>
                                    <Typography variant="h6">
                                        Daftar Pesanan
                                    </Typography>
                                    <Divider />
                                    <br />

                                    <TableContainer component={Paper}>
                                        <Table stickyHeader size="small" aria-label="sticky table">
                                            <TableHead>
                                                <TableRow>
                                                    <StyledTableCell align="center">Nama</StyledTableCell>
                                                    <StyledTableCell align="center">Harga</StyledTableCell>
                                                    <StyledTableCell align="center">Diskon</StyledTableCell>
                                                    <StyledTableCell align="center">Jumlah</StyledTableCell>
                                                    <StyledTableCell align="center">Subtotal</StyledTableCell>
                                                    <StyledTableCell align="center">Aksi</StyledTableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {data_input_pesanan.map((data_input_pesanan, index) => {
                                                    return (
                                                        <StyledTableRow key={data_input_pesanan.id_produk}>
                                                            <TableCell size="small"><Typography variant="body2" noWrap={true}>{data_input_pesanan.nama}</Typography></TableCell>
                                                            <TableCell size="small" align="right"><Typography variant="body2" noWrap={true}>{format_rupiah(parseFloat(data_input_pesanan.harga))}</Typography></TableCell>
                                                            <TableCell size="small" align="right"><Typography variant="body2" noWrap={true} sx={{ color: "green" }}>{parseFloat(data_input_pesanan.diskon_nominal) !== 0 ? "-" : ""} {format_rupiah(parseFloat(data_input_pesanan.diskon_nominal))}</Typography></TableCell>
                                                            <TableCell size="small" align="center" sx={{ whiteSpace: "nowrap" }}>
                                                                <Fab
                                                                    color="primary"
                                                                    size="small"
                                                                    style={{ backgroundColor: "gray" }}
                                                                    // onClick={() => kurang_pesanan(data_input_pesanan.id_produk, data_input_pesanan.jumlah_minimal, data_input_pesanan.no_tambahan)}
                                                                    onClick={() => kurang_pesanan(index)}
                                                                >
                                                                    <RemoveIcon />
                                                                </Fab>
                                                                <TextField
                                                                    variant="outlined"
                                                                    size="small"
                                                                    inputProps={{
                                                                        style: { textAlign: "center", width: "50px" }
                                                                    }}
                                                                    // value={data_input_pesanan.jumlah}
                                                                    // onChange={(e) => ubah_jumlah_pesanan(e, data_input_pesanan.id_produk, data_input_pesanan.no_tambahan)}
                                                                    // onBlur={(e) => perbaiki_pesanan(e, data_input_pesanan.id_produk, data_input_pesanan.jumlah_minimal, data_input_pesanan.no_tambahan)}
                                                                    value={data_input_pesanan.jumlah}
                                                                    onChange={(e) => ubah_jumlah_pesanan(e, index)}
                                                                    onBlur={(e) => perbaiki_pesanan(e, index)}
                                                                />
                                                                <Fab
                                                                    color="primary"
                                                                    size="small"
                                                                    style={{ backgroundColor: "gray" }}
                                                                    // onClick={() => tambah_pesanan(data_input_pesanan.id_produk, data_input_pesanan.no_tambahan)}
                                                                    onClick={() => tambah_pesanan(index)}
                                                                >
                                                                    <AddIcon />
                                                                </Fab>
                                                            </TableCell>
                                                            <TableCell size="small" align="right">
                                                                {/* <Typography variant="body2" noWrap={true}>
                                                                    {data_input_pesanan.subtotal2}
                                                                </Typography> */}
                                                                <Typography variant="body2" noWrap={true}>
                                                                    {format_rupiah(parseFloat(data_input_pesanan.jumlah) * (parseFloat(data_input_pesanan.harga) - parseFloat(data_input_pesanan.diskon_nominal)))}
                                                                </Typography>
                                                                <Typography variant="caption" noWrap={true}
                                                                    sx={
                                                                        parseFloat(tambah_jual) === 0 ? { display: "none", color: "red" } : { color: "red" }
                                                                    }
                                                                >
                                                                    +{format_rupiah(parseFloat(data_input_pesanan.jumlah) * (parseFloat(data_input_pesanan.harga) - parseFloat(data_input_pesanan.diskon_nominal)) * parseFloat(tambah_jual) / 100)}
                                                                </Typography>
                                                            </TableCell>
                                                            <TableCell size="small" align="center">
                                                                <Fab
                                                                    color="primary"
                                                                    size="small"
                                                                    style={data_input_pesanan.tambahan === "1" ? { backgroundColor: "red" } : { display: "none" }}
                                                                    // onClick={() => hapus_pesanan(data_input_pesanan.id_produk)}
                                                                    onClick={() => hapus_pesanan(index)}
                                                                >
                                                                    <DeleteIcon />
                                                                </Fab>
                                                            </TableCell>
                                                        </StyledTableRow>
                                                    );
                                                })}

                                                <TableRow>
                                                    <TableCell align="right" colSpan={4}>
                                                        <Typography variant="h6">
                                                            Total
                                                        </Typography>
                                                    </TableCell>
                                                    <TableCell align="right"><Typography variant="h6" noWrap={true} sx={{ color: "red" }}>
                                                        {/* {format_rupiah(total)} */}
                                                        {format_rupiah(parseFloat(hitung_total()))}
                                                    </Typography></TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Card>
                            </Grid>

                            <Grid item xs={12} md={7}>
                                <Grid container>
                                    <Grid container>
                                        <TextField
                                            id="input-with-icon-textfield"
                                            label="Cari berdasarkan nama produk (tekan Enter)"
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            sx={{ margin: "10px" }}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <SearchOutlined
                                                            onClick={() => cari()}
                                                        />
                                                    </InputAdornment>
                                                ),
                                            }}
                                            value={pencarian}
                                            onChange={(event) => setPencarian(event.target.value)}
                                            onKeyPress={(event) => {
                                                if (event.key === "Enter") {
                                                    cari();
                                                }
                                            }}
                                        />
                                    </Grid>

                                    <Grid
                                        item xs={12}
                                    >
                                        <Stack spacing={2}>
                                            <Pagination
                                                color="primary"
                                                count={jumlah_halaman}
                                                page={halaman}
                                                onChange={(event, nomor) => {
                                                    pindah_halaman(nomor);
                                                }}
                                            />
                                        </Stack>
                                    </Grid>

                                    <Grid container spacing={1}>
                                        {data_produk.map((data_produk) => {
                                            return (
                                                <Grid
                                                    key={data_produk.id_produk}
                                                    sx={{ margin: "10px", width: "150px" }}
                                                    onClick={() => {
                                                        var tampung = [];
                                                        var awal, akhir = 0;
                                                        if (data_input_pesanan.length > 0) {
                                                            tampung = [...data_input_pesanan];
                                                            awal = 1;
                                                            akhir = tampung.length;
                                                            var cari = "";
                                                            while (awal <= akhir) {
                                                                if (tampung[awal - 1]["id_produk"] === data_produk.id_produk) {
                                                                    tampung[awal - 1]["jumlah"] = parseInt(tampung[awal - 1]["jumlah"]) + 1;
                                                                    // tampung[awal - 1]["subtotal"] = parseInt(tampung[awal - 1]["jumlah"]) * parseInt(tampung[awal - 1]["harga"]);
                                                                    // tampung[awal - 1]["subtotal"] = parseFloat(tampung[awal - 1]["jumlah"]) * (parseFloat(tampung[awal - 1]["harga"] - tampung[awal - 1]["diskon_nominal"]));
                                                                    // tampung[awal - 1]["subtotal2"] = format_rupiah(tampung[awal - 1]["subtotal"]);
                                                                    cari = "ada";
                                                                    break;
                                                                }
                                                                awal++;
                                                            }

                                                            if (cari === "") {
                                                                tampung.push({
                                                                    "id_jenis": data_produk.id_jenis,
                                                                    "jenis": data_produk.jenis,
                                                                    "id_produk": data_produk.id_produk,
                                                                    "nama": data_produk.nama,
                                                                    "hpp": data_produk.hpp,
                                                                    "jumlah": 1,
                                                                    "harga": data_produk.harga,
                                                                    // "harga2": data_produk.harga2, 
                                                                    "diskon_persen": data_produk.diskon_persen,
                                                                    "diskon_nominal": data_produk.diskon_nominal,
                                                                    // "subtotal": data_produk.harga - data_produk.diskon_nominal, 
                                                                    // "subtotal2": format_rupiah(data_produk.harga - data_produk.diskon_nominal), 
                                                                    "tambahan": "1",
                                                                    "no_tambahan": null
                                                                });
                                                            }
                                                        }
                                                        else {
                                                            tampung.push({
                                                                "id_jenis": data_produk.id_jenis,
                                                                "jenis": data_produk.jenis,
                                                                "id_produk": data_produk.id_produk,
                                                                "nama": data_produk.nama,
                                                                "hpp": data_produk.hpp,
                                                                "jumlah": 1,
                                                                "harga": data_produk.harga,
                                                                // "harga2": data_produk.harga2, 
                                                                "diskon_persen": data_produk.diskon_persen,
                                                                "diskon_nominal": data_produk.diskon_nominal,
                                                                // "subtotal": data_produk.harga - data_produk.diskon_nominal, 
                                                                // "subtotal2": format_rupiah(data_produk.harga - data_produk.diskon_nominal), 
                                                                "tambahan": "1",
                                                                "no_tambahan": null
                                                            });
                                                        }

                                                        // var total = 0;
                                                        // awal = 1;
                                                        // akhir = tampung.length;
                                                        // while (awal <= akhir) {
                                                        //     total = total + parseFloat(tampung[awal - 1]["subtotal"]);
                                                        //     awal++;
                                                        // }

                                                        setDataInputPesanan(tampung);
                                                        // setTotal(total);
                                                    }}
                                                >
                                                    <Card>
                                                        <ImageListItem>
                                                            <CardMedia
                                                                component="img"
                                                                src={props.file + "/Foto/Produk/" + data_produk.foto}
                                                                sx={{
                                                                    backgroundColor: "gray",
                                                                    width: "150px",
                                                                    height: "150px"
                                                                }}
                                                            />
                                                            <ImageListItemBar
                                                                title={data_produk.nama}
                                                                subtitle={"Rp. " + format_rupiah(parseFloat(data_produk.harga - data_produk.diskon_nominal))}
                                                            />
                                                        </ImageListItem>
                                                    </Card>
                                                </Grid>
                                            );
                                        })}
                                    </Grid>

                                    <Grid
                                        item xs={12}
                                    >
                                        <Stack spacing={2}>
                                            <Pagination
                                                color="primary"
                                                count={jumlah_halaman}
                                                page={halaman}
                                                onChange={(event, nomor) => {
                                                    pindah_halaman(nomor);
                                                }}
                                            />
                                        </Stack>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
            </Dialog>
        </div>
    );
}

export default forwardRef(Pembayaran);